import "./assets/scss/style.scss";

import { ViteSSG } from "vite-ssg";
import { createPinia } from "pinia";
import App from "./App.vue";
import { routes } from "./router";

import { useSettingsStore } from "@/stores/settingsStore";
import { useScrollStore } from "@/stores/scrollStore";
import { useSertStore } from "@/stores/sertStore";
import { useRequestsStore } from "@/stores/storeRequests";

export const createApp = ViteSSG(
    App,
    { routes: [{ path: "/", component: App }] }, // единственный маршрут для SSG
    ({ app, router, initialState }) => {
        const pinia = createPinia();
        app.use(pinia);

        // Восстановление состояния Pinia на клиенте
        if (import.meta.env.SSR) {
            initialState.pinia = pinia.state.value;
        } else {
            pinia.state.value = initialState.pinia || {};
        }

        // Инициализация сторов перед навигацией
        router.beforeEach((to, from, next) => {
            const storeRequests = useRequestsStore(pinia);
            const settingsStore = useSettingsStore(pinia);
            const scrollStore = useScrollStore(pinia);
            const sertStore = useSertStore(pinia);

            if (!storeRequests.ready) storeRequests.initialize?.();
            if (!sertStore.ready) sertStore.initialize?.();
            if (!settingsStore.ready) settingsStore.initialize?.();
            if (!scrollStore.ready) scrollStore.initialize?.();

            next();
        });
    }
);
